import Vue from "vue"
import config from '../config'

export default {
    getOne(id, params = {}){
        return Vue.http.get(config.apiBaseUrl + '/requests/' + id, { params }).then((response) => response.json());
    },
    getList(params = {}){
        return Vue.http.get(config.apiBaseUrl + '/requests', { params }).then((response) => response.json());
    },

    getRequestsWithZepplinId(params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/requests-zepplin', { params }).then((response) => response.json());
    },

    removeOne(id, params = {}){
        return Vue.http.delete(config.apiBaseUrl + '/requests/' + id, { params }).then((response) => response.json());
    },

    getListByDate(date, params = {}) {
        return Vue.http.get(config.apiBaseUrl + `/requests/date/${date}`, { params }).then((response) => response.json());
    },

    createRequest(body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/requests', body, { params }).then((response) => response.json()) 
    },

    updateRequest(body, requestId) {
        return Vue.http.patch(config.apiBaseUrl + `/requests/${requestId}`, body).then((response) => response.json())
    },

    createRequestOrder(body, requestId, params = {}){
        return Vue.http.post(config.apiBaseUrl + `/requests/${requestId}/request-orders`, body, { params }).then((response) => response.json()) 
    },

    updateRequestOrder(body, requestOrderId) {
        return Vue.http.patch(config.apiBaseUrl + `/request-orders/${requestOrderId}`, body).then((response) => response.json())
    },

    createRequestContact(body, requestId, params = {}){
        return Vue.http.post(config.apiBaseUrl + `/requests/${requestId}/request-contacts`, body, { params }).then((response) => response.json()) 
    },

    updateRequesContact(body, requestContactId) {
        return Vue.http.patch(config.apiBaseUrl + `/request-contacts/${requestContactId}`, body).then((response) => response.json())
    },

    setRequestOrderProducts(body, requestOrderId) {
        return Vue.http.put(config.apiBaseUrl + `/request-orders/${requestOrderId}/request-order-products`, body, { 
            headers: { 'Content-type': 'application/json' }
        }).then((response) => response.json()) 
    },

    setRequestOrderPayments(body, requestOrderId) {
        return Vue.http.put(config.apiBaseUrl + `/request-orders/${requestOrderId}/request-order-payments`, body, { 
            headers: { 'Content-type': 'application/json' }
        }).then((response) => response.json()) 
    },

    markAs(body, action, params = {}) {
        return Vue.http.post(config.apiBaseUrl + `/requests/mark-as/${action}`, body, { params }).then(response => response.json())
    },
    markAsNot(body, action, params = {}) {
        return Vue.http.post(config.apiBaseUrl + `/requests/mark-as-not/${action}`, body, { params }).then(response => response.json())
    },

    getLogs(requestId, params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/requests/logs/' + requestId, { params }).then((response) => response.json())
    },

    createRequestChatItem(requestId, data, params = {}) {
        return Vue.http.post(`${config.apiBaseUrl}/requests/${requestId}/request-chat-items`, data, { params }).then((response) => response.json())
    },
    getRequestChatItems(requestId, params = {}){
        return Vue.http.get(`${config.apiBaseUrl}/requests/${requestId}/request-chat-items`, { params }).then((response) => response.json());
    },
    markChatItemsStatus(requestId, data, params = {}){
        return Vue.http.put(`${config.apiBaseUrl}/requests/${requestId}/chat-items/mark`, data, { params }).then((response) => response.json());
    },
}
